<template
  ><div>
    <h2>
      <span> {{ $t("config.update") }}</span>
    </h2>

    <div class="text-right">
      <a class="text-main hand mr-2" style="font-size: 24px;" @click="copy" v-b-tooltip.hover :title="$t('common.copy-to-clipboard')"><i class="bx bxs-copy"></i></a>
      <a class="text-main hand" style="font-size: 24px;" @click="paste" v-b-tooltip.hover :title="$t('common.fill-form-from-clipboard')"><i class="bx bx-paste"></i></a>
    </div>

    <form @submit.prevent>
      <div>
        <!-- form input start-->
        <sweet-input
          v-model="form.emailHost"
          :isValid="!$v.form.emailHost.$error"
          @input="$v.form.emailHost.$touch()"
          layout="vertical"
          placeholder="emailHost"
          :label="$t('config.email-host')"
          class="mt-2"
        />

        <sweet-input
          type="number"
          v-model="form.emailPort"
          :isValid="!$v.form.emailPort.$error"
          @input="$v.form.emailPort.$touch()"
          layout="vertical"
          placeholder="emailPort"
          :label="$t('config.email-port')"
          class="mt-2"
        />

        <sweet-input
          v-model="form.emailAccount"
          :isValid="!$v.form.emailAccount.$error"
          @input="$v.form.emailAccount.$touch()"
          layout="vertical"
          placeholder="emailAccount"
          :label="$t('config.email-account')"
          class="mt-2"
        />

        <sweet-input
          v-model="form.emailPwd"
          :isValid="!$v.form.emailPwd.$error"
          @input="$v.form.emailPwd.$touch()"
          layout="vertical"
          placeholder="emailPwd"
          :label="$t('config.email-pwd')"
          class="mt-2"
        />

        <sweet-input
          v-model="form.emailFrom"
          :isValid="!$v.form.emailFrom.$error"
          @input="$v.form.emailFrom.$touch()"
          layout="vertical"
          placeholder="emailFrom"
          :label="$t('config.email-from')"
          class="mt-2"
        />

        <b-form-checkbox v-model="form.emailTlsRejectUnauthorized" switch class="mt-2">{{ $t("config.email-tls-reject-unauthorized") }} </b-form-checkbox>

        <h6 class="mt-4">{{ $t("config.translate-service") }}</h6>
        <select class="form-control " v-model="form.translateService">
          <option value="NONE">{{ $t("config.translate-service-single") }}</option>
          <option value="GOOGLE">{{ $t("config.translate-service-google") }}</option>
          <option value="LIBRE">{{ $t("config.translate-service-libre") }}</option>
        </select>

        <sweet-input
          v-if="form.translateService == 'GOOGLE'"
          v-model="form.translateApiKey"
          :isValid="!$v.form.translateApiKey.$error"
          @input="$v.form.translateApiKey.$touch()"
          layout="vertical"
          placeholder="translateApiKey"
          :label="$t('config.translate-api-key')"
          class="mt-2"
        />

        <sweet-input
          type="number"
          v-model="form.cacheExpireTime"
          :isValid="!$v.form.cacheExpireTime.$error"
          @input="$v.form.cacheExpireTime.$touch()"
          layout="vertical"
          placeholder="cacheExpireTime"
          :label="$t('config.cache-expire-time')"
          class="mt-2"
        />

        <b-form-checkbox v-model="form.enableLastThreeDistinctPassword" switch class="mt-2">
          {{ $t("config.enable-last-three-distinct-password") }}
        </b-form-checkbox>
        <b-form-checkbox v-model="form.enableMultipleLogin" switch class="mt-2">{{ $t("config.enable-multiple-auth") }} </b-form-checkbox>

        <b-form-checkbox v-model="form.enableRecaptcha" switch class="mt-2">{{ $t("config.enable-recaptcha") }} </b-form-checkbox>
        <sweet-input
          v-if="form.enableRecaptcha"
          v-model="form.recaptchaKey"
          :isValid="!$v.form.recaptchaKey.$error"
          @input="$v.form.recaptchaKey.$touch()"
          layout="vertical"
          placeholder="recaptchaKey"
          :label="$t('config.recaptcha-key') + ' (recaptchaKey)'"
          class="mt-2"
        />

        <b-form-checkbox v-model="form.enablePasswordExpiration" switch class="mt-2">{{ $t("config.enable-password-expiration") }} </b-form-checkbox>
        <sweet-input
          v-if="form.enablePasswordExpiration"
          :isValid="!$v.form.passwordMaxLifeTime.$error"
          type="number"
          v-model="form.passwordMaxLifeTime"
          layout="vertical"
          placeholder="passwordMaxLifeTime"
          :label="$t('config.password-max-lifetime')"
          class="mt-2"
        />
        <sweet-input
          v-if="form.enablePasswordExpiration"
          :isValid="!$v.form.passwordMinLifeTime.$error"
          type="number"
          v-model="form.passwordMinLifeTime"
          layout="vertical"
          placeholder="passwordMinLifeTime"
          :label="$t('config.password-min-lifetime')"
          class="mt-2"
        />

        <b-form-checkbox v-model="form.enableAccountDeactivation" switch class="mt-2">{{ $t("config.enable-account-deactivation") }} </b-form-checkbox>

        <sweet-input
          v-if="form.enableAccountDeactivation"
          :isValid="!$v.form.accountDeactivationTime.$error"
          type="number"
          v-model="form.accountDeactivationTime"
          layout="vertical"
          placeholder="accountDeactivationTime"
          :label="$t('config.account-deactivation-time')"
          class="mt-2"
        />

        <b-form-checkbox v-model="form.enableFailedLoginAttempsDeactivation" switch class="mt-2">{{ $t("config.enable-failed-login-attemps-deactivation") }} </b-form-checkbox>
        <sweet-input
          v-if="form.enableFailedLoginAttempsDeactivation"
          v-model="form.maxFailedLoginAttemps"
          :isValid="!$v.form.maxFailedLoginAttemps.$error"
          @input="$v.form.maxFailedLoginAttemps.$touch()"
          layout="vertical"
          placeholder="maxFailedLoginAttemps"
          :label="$t('config.max-failed-login-attemps')"
          class="mt-2"
        />

        <b-form-checkbox v-model="form.enableWhiteLabel" switch class="d-inline-block mt-2">{{ $t("config.enable-white-label") }} </b-form-checkbox>
        <div class="d-inline-block ml-2" v-if="form.whiteLabel">
          <img :src="form.whiteLabel" alt="whiteLabel" width="20" />
        </div>
        <br />

        <input v-if="form.enableWhiteLabel" accept=".png, .PNG" placeholder="whiteLabel" :label="$t('config.white-label')" class="mt-2" type="file" @change="handleFileChange" />

        <h6 class="mt-4">{{ $t("config.inventory-template") }}</h6>
        <div class="d-flex align-items-center mb-2">
          <sweet-button
            v-if="form.inventoryTemplate && form.inventoryTemplate.data"
            variant="info"
            size="xs"
            icon="mdi mdi-download"
            class="mr-2"
            @click="downloadInventoryTemplate"
          >
            {{ $t("config.inventory-template-download") }}
          </sweet-button>
          <span v-if="form.inventoryTemplate && form.inventoryTemplate.updatedAt" class="text-muted">
            {{ $t("config.inventory-template-last-updated", { date: $options.filters.date(form.inventoryTemplate.updatedAt, true) }) }}
          </span>
          <span v-else class="text-muted">{{ $t("inventory-import.template.missing") }}</span>
        </div>
        <input accept=".xlsx,.xls" class="mt-2" type="file" @change="handleInventoryTemplateChange" />

        <b-form-checkbox v-model="form.enableTwoFactorAuthentication" switch class="mt-2">{{ $t("config.enable-two-factor-authentication") }} </b-form-checkbox>
        <select v-if="form.enableTwoFactorAuthentication" class="form-control " v-model="form.twoFactorAuthenticationMethod">
          <option value="AZURE_ACTIVE_DIRECTORY">{{ $t("config.two-factor-authentication-method.azure-active-directory") }}</option>
        </select>

        <sweet-input
          v-if="form.enableTwoFactorAuthentication && form.twoFactorAuthenticationMethod == 'AZURE_ACTIVE_DIRECTORY'"
          :isValid="!$v.form.azureAdTenantId.$error"
          v-model="form.azureAdTenantId"
          layout="vertical"
          placeholder="azureAdTenantId"
          :label="$t('config.azuread-tenant-id')"
          class="mt-2"
        />
        <sweet-input
          v-if="form.enableTwoFactorAuthentication && form.twoFactorAuthenticationMethod == 'AZURE_ACTIVE_DIRECTORY'"
          :isValid="!$v.form.azureAdClientId.$error"
          v-model="form.azureAdClientId"
          layout="vertical"
          placeholder="azureAdClientId"
          :label="$t('config.azuread-client-id')"
          class="mt-2"
        />
        <sweet-input
          v-if="form.enableTwoFactorAuthentication && form.twoFactorAuthenticationMethod == 'AZURE_ACTIVE_DIRECTORY'"
          :isValid="!$v.form.azureAdClientSecret.$error"
          v-model="form.azureAdClientSecret"
          layout="vertical"
          placeholder="azureAdClientSecret"
          :label="$t('config.azuread-client-secret')"
          class="mt-2"
        />

        <br />
        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>
      </div>
    </form>
  </div>
  <!-- form input end -->
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
const state = "managementConfig";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  data() {
    return {
      form: {},
      formError: undefined,
    };
  },
  validations: {
    form: {
      emailHost: {
        required,
      },
      emailPort: {
        required,
      },
      emailAccount: {
        required,
      },
      emailPwd: {
        required,
      },
      emailFrom: {
        required,
      },
      recaptchaKey: {
        required: requiredIf(function(form) {
          return form.enableRecaptcha;
        }),
      },
      enableRecaptcha: {
        required,
      },
      cacheExpireTime: {
        required,
      },
      enableMultipleLogin: {
        required,
      },
      enablePasswordExpiration: {
        required,
      },
      passwordMaxLifeTime: {
        required: requiredIf(function(form) {
          return form.enablePasswordExpiration;
        }),
      },
      passwordMinLifeTime: {
        required: requiredIf(function(form) {
          return form.enablePasswordExpiration;
        }),
      },
      enableLastThreeDistinctPassword: {
        required,
      },
      enableAccountDeactivation: {
        required,
      },
      accountDeactivationTime: {
        required: requiredIf(function(form) {
          return form.enableAccountDeactivation;
        }),
      },
      enableFailedLoginAttempsDeactivation: {
        required,
      },
      maxFailedLoginAttemps: {
        required: requiredIf(function(form) {
          return form.enableFailedLoginAttempsDeactivation;
        }),
      },
      translateApiKey: {
        required: requiredIf(function(form) {
          return form.translateService != "GOOGLE";
        }),
      },
      enableWhiteLabel: {
        required,
      },
      twoFactorAuthenticationMethod: {
        required: requiredIf(function(form) {
          return form.enableTwoFactorAuthentication;
        }),
      },
      azureAdTenantId: {
        required: requiredIf(function(form) {
          return form.twoFactorAuthenticationMethod == "AZURE_ACTIVE_DIRECTORY";
        }),
      },
      azureAdClientId: {
        required: requiredIf(function(form) {
          return form.twoFactorAuthenticationMethod == "AZURE_ACTIVE_DIRECTORY";
        }),
      },
      azureAdClientSecret: {
        required: requiredIf(function(form) {
          return form.twoFactorAuthenticationMethod == "AZURE_ACTIVE_DIRECTORY";
        }),
      },

      // whiteLabel: {
      //   required: requiredIf(function(form) {
      //     return form.enableWhiteLabel;
      //   }),
      // },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = JSON.parse(JSON.stringify(v || {}));
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
  },
  mounted() {},
  methods: {
    handleFileChange(event) {
      const files = event.target.files;
      if (files.length > 0) {
        const fileSize = files[0].size;
        const maksFileSize = 2; //2mb
        if (fileSize > maksFileSize * 1024 * 1024) {
          this.$toast.error(this.$t("config.maks-file-size", { size: maksFileSize }));
          return;
        }

        this.convertFileToBase64(files[0], (dataUrl) => {
          this.form.whiteLabel = dataUrl;
        });
      }
    },
    handleInventoryTemplateChange(event) {
      const files = event.target.files;
      if (!files || files.length === 0) {
        return;
      }
      const file = files[0];
      const maksFileSize = 5; //5mb
      if (file.size > maksFileSize * 1024 * 1024) {
        this.$toast.error(this.$t("config.maks-file-size", { size: maksFileSize }));
        return;
      }

      this.convertFileToBase64(file, (dataUrl) => {
        this.form.inventoryTemplate = {
          data: dataUrl,
          fileName: file.name,
          updatedAt: new Date().toISOString(),
        };
      });
    },
    convertFileToBase64(file, callback) {
      const reader = new FileReader();
      reader.onload = (e) => {
        callback(e.target.result);
      };
      reader.readAsDataURL(file);
    },
    downloadInventoryTemplate() {
      if (!this.form.inventoryTemplate || !this.form.inventoryTemplate.data) {
        return;
      }

      const link = document.createElement("a");
      link.href = this.form.inventoryTemplate.data;
      link.download = this.form.inventoryTemplate.fileName || "inventory-template.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    copy() {
      const jsonString = JSON.stringify(this.form, null, 2);

      navigator.clipboard
        .writeText(jsonString)
        .then(() => {
          this.$toast.success(this.$t("common.copy-to-clipboard-success"));
        })
        .catch((error) => {
          this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.copy-to-clipboard-fail") });
        });
    },
    paste() {
      navigator.clipboard
        .readText()
        .then((text) => {
          try {
            const parsedData = JSON.parse(text);
            this.form = { ...parsedData };
          } catch (error) {
            this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.invalid-json") });
          }
        })
        .catch((error) => {
          this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.paste-from-clipboard-fail") });
        });
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/update`, this.form);
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-edit-config");
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
